import React, { Suspense } from 'react';
import Loading from 'components/Loading';

const Campaigns = React.lazy(() => import('./Campaigns'));

export default function CampaignsCollection(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Campaigns {...props} />
    </Suspense>
  );
}
